import { ArrowDownIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ArrowDownBold = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ArrowDownIcon {...rest} size={Sizes[size]} color={fill} />;
};

ArrowDownBold.displayName = 'ArrowDownBold';
